import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngxs/store';
import { AddWalletPaymentMethod, isReusablePaymentMethodType, PaymentMethodType, ReusablePaymentMethodType } from '@platform-frontend/marketplace';
import { Navigate } from '@platform-frontend/util';

@Injectable({
  providedIn: 'root'
})
export class AddPaymentMethodService {
  constructor(private store: Store) {}

  addPaymentMethodNavigation(paymentMethodType: PaymentMethodType, activatedRoute: ActivatedRoute, walletRoute?: string): void {
    const extras = {
      relativeTo: activatedRoute
    };
    if (isReusablePaymentMethodType(paymentMethodType)) {
      this.store.dispatch(new Navigate([this.getUrl(paymentMethodType)], { ...extras, queryParams: { paymentMethod: paymentMethodType } }));
    } else {
      this.store.dispatch(
        walletRoute ? [new AddWalletPaymentMethod(paymentMethodType), new Navigate([walletRoute], extras)] : new AddWalletPaymentMethod(paymentMethodType)
      );
    }
  }

  private getUrl(paymentMethodType: ReusablePaymentMethodType): string {
    switch (paymentMethodType) {
      case 'CREDIT_CARD':
      case 'DIRECT_DEBIT':
      case 'TEAM_BUDGET':
        return '../payment-method-with-data';
      case 'PAY_PAL':
        return '../payment-method-with-polling';
    }
  }
}
